import { Route, Routes } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';

import { CreatePoliceReportPage } from './CreatePoliceReportPage';
import { EditPoliceReportPage } from './EditPoliceReportPage';
import { PoliceOverviewPage } from './PoliceOverviewPage';

export const PoliceRoutes = () => {
  const { matterId } = useMatter();

  return (
    <Routes>
      <Route path="/" element={<PoliceOverviewPage matterId={matterId} />} />
      <Route path="/create" element={<CreatePoliceReportPage />} />

      <Route
        path="/:police_report_id"
        element={<PoliceOverviewPage matterId={matterId} />}
      />
      <Route
        path="/:police_report_id/edit"
        element={<EditPoliceReportPage />}
      />
    </Routes>
  );
};
